// extracted by mini-css-extract-plugin
export default {"container":"MediaContainer_container__rewQm"};